/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Skill } from '../../models/skill';

export interface GetSkill$Params {

/**
 * Skill id of a resource
 */
  skill_id: string;
}

export function getSkill(http: HttpClient, rootUrl: string, params: GetSkill$Params, context?: HttpContext): Observable<StrictHttpResponse<Skill>> {
  const rb = new RequestBuilder(rootUrl, getSkill.PATH, 'get');
  if (params) {
    rb.path('skill_id', params.skill_id, {"style":"simple","explode":false});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Skill>;
    })
  );
}

getSkill.PATH = '/api/v1/skills/{skill_id}';
